import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/makeinterviewgreatagain/makeinterviewgreatagain/src/components/LegalDoc.tsx");
